import React, {useState} from 'react';
import { Button } from './Styles';
import ScrollTopBtn from '../../assets/images/scroll_top.svg'
  
const ScrollButton = () =>{
  
  const [visible, setVisible] = useState(false)
  
  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;
    if (scrolled > 300){
      setVisible(true)
    } 
    else if (scrolled <= 300){
      setVisible(false)
    }
  };
  
  const scrollToTop = () =>{
    window.scrollTo({
      top: 0, 
      behavior: 'smooth'
    });
  };
  
  window.addEventListener('scroll', toggleVisible);
  
  return (
    <Button>
     {/* <FaArrowCircleUp onClick={scrollToTop} 
     style={{display: visible ? 'inline' : 'none'}} /> */}
     {visible && <figure>
        <img src={ScrollTopBtn} alt='scroll top icon' onClick={scrollToTop} height={60} width={60} />
        <figcaption>Top</figcaption>
       </figure>}
    </Button>
  );
}
  
export default ScrollButton;